module.exports = __webpack_public_path__ + "6a767c4c841759ee562d46fa96da0b50.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/trendarticle_2.jpg
// module id = 308
// module chunks = 0